import React from 'react';
import TableFilterSelect from './TableFilterSelect';
import FilterModal from './FilterModal';

const TableFilters = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  function onOpen() {
    setIsOpen(true);
  }

  function onClose() {
    setIsOpen(false);
  }

  return (
    <>
      <TableFilterSelect onOpen={onOpen} />
      <FilterModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default TableFilters;
